<template>
  <div>
    <input type="file" @change='readWorkbookFromLocalFile($event)' ref='dataFile'>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapState } from 'vuex'
export default {
  name: 'exportExl',
  data () {
    return {
      msg: 'exportExl'
    }
  },
  computed: {
    ...mapState({
    })
  },
  components: { },
  methods: {
    // 原读取excel文件的方法
    readWorkbookFromLocalFile (file, callback) {
      // let self = this
      // 文件本身
      // console.log(file.srcElement.files[0])
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        var workbook = XLSX.read(data, { type: 'binary' })
        // console.log(workbook)
        // var sheetNames = workbook.SheetNames // 工作表名称集合
        var worksheet = workbook.Sheets // 这里我们只读取第一张sheet
        // console.log(worksheet)
        const allName = Object.keys(worksheet)
        allName.forEach((element, index) => {
          // 循环遍历数据去除数据中的回车以及上引号
          const message = worksheet[element].w
          if (message) {
            worksheet[element].w = worksheet[element].w.replace(/"/g, '').replace(/\n/g, '')
          }
        })
        // let csvdata = XLSX.utils.sheet_to_csv(worksheet.Sheet1)
        const csvJson = XLSX.utils.sheet_to_json(worksheet.Sheet1)
        // console.log(csvJson)
        // self.exportExcel(csvdata)
        // console.log(`${workbook.Sheets.Sheet1.C2.v}`.split('\n'))
        if (callback) callback(workbook, csvJson)
      }
      reader.readAsBinaryString(file.srcElement.files[0])
    },
    csv2sheet (csv) {
      var sheet = {} // 将要生成的sheet
      csv = csv.split('\n')
      csv.forEach(function (row, i) {
        row = row.split(',')
        if (i === 0) sheet['!ref'] = 'A1:' + String.fromCharCode(65 + row.length - 1) + (csv.length - 1)
        row.forEach(function (col, j) {
          sheet[String.fromCharCode(65 + j) + (i + 1)] = { v: col }
        })
      })
      return sheet
    },
    // 将一个多维数组转换成sheet对象
    arrToDownload (arr, name, mergeArr) {
      if (!(arr instanceof Array)) {
        return false
      }
      var sheet = XLSX.utils.aoa_to_sheet(arr)
      if (mergeArr instanceof Array) {
        const selfArr = []
        mergeArr.forEach((value) => {
          selfArr.push({
            s: { r: value[0][0], c: value[0][1] },
            e: { r: value[1][0], c: value[1][1] }
          })
        })
        sheet['!merges'] = selfArr
      }
      this.openDownloadDialog(this.sheet2blob(sheet), `${name}.xlsx`)
    },
    // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
    sheet2blob (sheet, sheetName) {
      sheetName = sheetName || 'sheet1'
      var workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      }
      workbook.Sheets[sheetName] = sheet
      // 生成excel的配置项
      var wopts = {
        bookType: 'xlsx', // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: 'binary'
      }
      var wbout = XLSX.write(workbook, wopts)
      var blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      // 字符串转ArrayBuffer
      function s2ab (s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
        return buf
      }
      return blob
    },
    /**
     * 通用的打开下载对话框方法，没有测试过具体兼容性
     * @param url 下载地址，也可以是一个blob对象，必选
     * @param saveName 保存文件名，可选
     */
    openDownloadDialog (url, saveName) {
      if (typeof url === 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url) // 创建blob地址
      }
      var aLink = document.createElement('a')
      aLink.href = url
      aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event
      if (window.MouseEvent) {
        event = new MouseEvent('click')
      } else {
        event = document.createEvent('MouseEvents')
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      }
      aLink.dispatchEvent(event)
    },
    // 传入csv，执行后就会弹出下载框
    exportExcel (csv, fileName) {
      const csvData = csv + `
      , ,`
      const fileNameData = fileName || '数据'
      var sheet = this.csv2sheet(csvData)
      var blob = this.sheet2blob(sheet)
      this.openDownloadDialog(blob, fileNameData + '.xlsx')
    }
  },
  mounted () {
  }
}
</script>
